// extracted by mini-css-extract-plugin
module.exports = {"list":"StatusList_list__an-H-","labelItem":"StatusList_labelItem__3Zf01","checkbox":"StatusList_checkbox__1Kjpx"};